import {lazy} from 'react'
import * as B from '../block'
import {GlobalBlock as InnerBlock} from './GlobalBlock'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

export const globalBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
  wrapperDiv: false,
})
